import styled from "@emotion/styled";
import { Modal } from "scmp-sdk";

import { theme } from "shared/lib/styles";

import {
  CtaButton as PlusCtaButton,
  Container as PlusMessageContainer,
  Left as PlusMessageLeft,
  Right as PlusMessageRight,
} from "scmp-app/components/plus/blurb-popup/message/styles";

import SvgDailyPulseLogo from "./daily-pulse-logo.svg";
import SvgNewsAgendaLogo from "./news-agenda-logo.svg";
import SvgScmpPlusHighlightsLogo from "./scmp-plus-highlights-logo.svg";

export const Container = styled.div`
  display: none;
  ${theme.breakpoints.up("tablet")} {
    display: block;

    inline-size: 960px;
    margin-block: 0;
    margin-inline: 32px;
    padding: 32px;

    border: 2px solid #4585ff;
    border-radius: 12px;

    background: #ffffff;
    ${PlusMessageLeft} {
      font-size: 19px;
    }
  }
`;

export const CardItemWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const PlusBlurbMessageWrapper = styled.div`
  margin-block-start: 28px;

  ${theme.breakpoints.up("tablet")} {
    ${PlusMessageContainer} {
      gap: 28px;
      justify-content: space-between;

      padding: 0;

      border: 0;
    }
    ${PlusMessageRight} {
      flex-direction: column;
    }
    ${PlusMessageContainer} {
      align-items: flex-start;
    }

    ${PlusCtaButton} {
      inline-size: 216px;
    }
  }

  ${PlusMessageLeft} {
    max-inline-size: 652px;
  }
`;

export const StyledSvgDailyPulseLogo = styled(SvgDailyPulseLogo)``;

export const StyledSvgNewsAgendaLogo = styled(SvgNewsAgendaLogo)``;

export const StyledSvgScmpPlusHighlightsLogo = styled(SvgScmpPlusHighlightsLogo)``;

export const Backdrop = styled.div`
  position: fixed;
  inset-block: 0 0;
  inset-inline: 0 0;
  z-index: -1;

  -webkit-tap-highlight-color: transparent;

  background: #000000;

  opacity: 0.3;
`;

export const StyledModal = styled(Modal)``;
